// extracted by mini-css-extract-plugin
module.exports = {"btnCol":"paymentusagedetaiheader_btnCol__1U-fG"};